import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const faqs = [
  {
    q: 'Come lavorate senza ponteggi?',
    a: 'I nostri tecnici sono specializzati nel lavoro in quota con sistemi di sicurezza certificati: linee vita, imbracature e dispositivi anticaduta conformi alle normative europee. Questo elimina completamente il costo del ponteggio e riduce i tempi di intervento.',
  },
  {
    q: 'Quanto si risparmia rispetto ai metodi tradizionali?',
    a: 'Eliminando i costi di noleggio, montaggio e smontaggio dei ponteggi, il risparmio medio si aggira intorno al 60-70%. In alcuni casi, come condomini o edifici alti, il risparmio puo superare il 70%.',
  },
  {
    q: 'Che garanzia offrite sui lavori?',
    a: 'Offriamo garanzia scritta fino a 10 anni su materiali e manodopera. Per interventi con tecnologia RevoUltra, la garanzia puo estendersi fino a 25 anni. Ogni lavoro viene documentato con report fotografico pre e post intervento.',
  },
  {
    q: 'Effettuate lo smaltimento dell\'eternit/amianto?',
    a: 'Si, siamo certificati per la rimozione e lo smaltimento di coperture in eternit e materiali contenenti amianto. Operiamo in conformita con tutte le normative vigenti, incluso lo smaltimento in discariche autorizzate e il rilascio della documentazione necessaria.',
  },
  {
    q: 'Quanto tempo richiede un intervento?',
    a: 'La maggior parte degli interventi viene completata in 1-3 giorni lavorativi. Per lavori piu complessi come lo smaltimento eternit con rifacimento completo, i tempi possono variare da 5 a 10 giorni a seconda della superficie.',
  },
  {
    q: 'Lavorate anche su capannoni industriali?',
    a: 'Assolutamente si. Interveniamo su coperture residenziali, condominiali e industriali. Per i capannoni offriamo soluzioni specifiche come lamiere grecate per fotovoltaico e pannelli coibentati per l\'isolamento termico.',
  },
  {
    q: 'Il sopralluogo e davvero gratuito?',
    a: 'Si, il sopralluogo e completamente gratuito e senza alcun impegno. Un nostro tecnico specializzato visitera la vostra proprieta, valutera lo stato della copertura e vi fornira un preventivo dettagliato.',
  },
  {
    q: 'In quali zone operate?',
    a: 'Operiamo principalmente in Veneto, Lombardia, Emilia-Romagna, Friuli-Venezia Giulia, Trentino-Alto Adige, Piemonte e Liguria. Per interventi di grandi dimensioni, possiamo valutare anche altre regioni.',
  },
];

const FAQSection = () => {
  return (
    <section className="py-24 md:py-32 bg-slate-50 relative">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-[#FF5722] text-sm font-semibold uppercase tracking-wider">FAQ</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-3">
            Domande frequenti
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="bg-white border border-slate-200 rounded-xl px-6 data-[state=open]:border-[#FF5722]/30 data-[state=open]:shadow-md transition-all"
              >
                <AccordionTrigger className="text-slate-900 hover:text-[#FF5722] text-left text-sm font-medium py-5 hover:no-underline">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
